import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface TaxYearOption {
  text: string;
  [key: string]: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class CopyLegacyFilesService {
  constructor(private http: HttpClient) {}

  /**
   * Load tax years for Copy Legacy Files dropdown.
   * URL format: baseUrl/loadJsonObject?action_id=32172&sso_id={ssoId}
   */
  getTaxYears(baseUrl: string, ssoId: string): Observable<{ callSuccess: string; jsonObject?: TaxYearOption[]; errorMessage?: string }> {
    const url = `${baseUrl}/loadJsonObject?action_id=32172&sso_id=${encodeURIComponent(ssoId)}`;
    return this.http.get<{ callSuccess: string; jsonObject?: TaxYearOption[]; errorMessage?: string }>(
      url,
      { withCredentials: true }
    );
  }

  /**
   * Move legacy files to S3 for the given tax year.
   * URL format: adminApiUrl/moveLegacyFilestoS3?taxYear={taxYear}
   */
  moveLegacyFilestoS3(
    adminApiUrl: string,
    taxYear: string
  ): Observable<{ callSuccess: string; errorMessage?: string }> {
    const url = `${adminApiUrl}/moveLegacyFilestoS3?taxYear=${encodeURIComponent(taxYear)}`;
    return this.http.post<{ callSuccess: string; errorMessage?: string }>(
      url,
      null,
      { withCredentials: true }
    );
  }
}
